import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";

export default function ProfileScreen() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const [userData, setUserData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    birthDate: "",
    from: "",
    tel: "",
    email: "",
  });

  // --- Pridobi podatke o uporabniku iz Firestore
  useEffect(() => {
    if (!user) return;
    const fetchUserData = async () => {
      const ref = doc(db, "users", user.uid);
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const data = snap.data();
        setUserData(data);
        setFormData({
          firstName: data.firstName || "",
          lastName: data.lastName || "",
          birthDate: data.birthDate || "",
          from: data.from || "",
          tel: data.tel || "",
          email: data.email || "",
        });
      }
    };
    fetchUserData();
  }, [user]);

  // --- Shrani spremembe
  const handleSave = async () => {
    if (!user) return;
    try {
      const ref = doc(db, "users", user.uid);
      await setDoc(ref, formData, { merge: true });
      setUserData(formData);
      setIsEditing(false);
      alert("Profil uspešno posodobljen!");
    } catch (err) {
      console.error(err);
      alert("Napaka pri shranjevanju profila.");
    }
  };

  if (!userData) return <p style={{ textAlign: "center", marginTop: 50 }}>Nalaganje...</p>;

  return (
    <div style={containerStyle}>
      <div style={headerStyle}>
        <h1 style={{ margin: 0 }}>Moj profil</h1>
        <div>
          <button style={buttonStyle} onClick={() => navigate("/domov")}>Domov</button>
          <button style={{ ...buttonStyle, backgroundColor: "#e74c3c" }} onClick={logout}>Izpis</button>
        </div>
      </div>

      {/* --- Pregled podatkov --- */}
      {!isEditing ? (
        <div style={cardStyle}>
          <h2>Podatki o uporabniku</h2>
          <p><strong>Ime:</strong> {userData.firstName}</p>
          <p><strong>Priimek:</strong> {userData.lastName}</p>
          <p><strong>Datum rojstva:</strong> {userData.birthDate
            ? new Date(userData.birthDate).toLocaleDateString("sl-SI", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
            : ""}</p>
          <p><strong>Kraj bivanja:</strong> {userData.from}</p>
          <p><strong>Telefon:</strong> {userData.tel}</p>
          <p><strong>Email:</strong> {userData.email}</p>

          <div style={{ marginTop: 20 }}>
            <button style={buttonStyle} onClick={() => setIsEditing(true)}>
              Uredi profil
            </button>
          </div>
        </div>
      ) : (
        // --- Modalno okno za urejanje ---
        <div style={overlayStyle}>
          <div style={modalStyle}>
            <h2>Uredi profil</h2>
            <input
              style={inputStyle}
              placeholder="Ime"
              value={formData.firstName}
              onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
            />
            <input
              style={inputStyle}
              placeholder="Priimek"
              value={formData.lastName}
              onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
            />
            <input
              type="date"
              style={inputStyle}
              value={formData.birthDate}
              onChange={(e) => setFormData({ ...formData, birthDate: e.target.value })}
            />
            <input
              style={inputStyle}
              placeholder="Kraj bivanja"
              value={formData.from}
              onChange={(e) => setFormData({ ...formData, from: e.target.value })}
            />
            <input
              style={inputStyle}
              placeholder="Telefonska številka"
              type="tel"
              value={formData.tel}
              onChange={(e) => setFormData({ ...formData, tel: e.target.value })}
            />
            {/* <input
              style={inputStyle}
              placeholder="E-poštni naslov"
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            /> */}

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 20 }}>
              <button style={{ ...buttonStyle, backgroundColor: "#aaa" }} onClick={() => setIsEditing(false)}>Prekliči</button>
              <button style={buttonStyle} onClick={handleSave}>Shrani</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// --- Styling ---
const containerStyle = {
  maxWidth: "600px",
  margin: "40px auto",
  padding: 20,
  fontFamily: "Arial, sans-serif"
};

const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 20
};

const cardStyle = {
  backgroundColor: "#fff",
  padding: 25,
  borderRadius: 12,
  boxShadow: "0 4px 15px rgba(0,0,0,0.1)"
};

const buttonStyle = {
  padding: "8px 15px",
  marginLeft: 10,
  borderRadius: 6,
  border: "none",
  cursor: "pointer",
  backgroundColor: "#3498db",
  color: "#fff",
  fontWeight: "bold"
};

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000
};

const modalStyle = {
  backgroundColor: "#fff",
  padding: 30,
  borderRadius: 12,
  width: 400,
  display: "flex",
  flexDirection: "column",
  gap: 10
};

const inputStyle = {
  padding: "8px 10px",
  borderRadius: 6,
  border: "1px solid #ccc",
  fontSize: 14
};
